import React, { Fragment, useEffect } from 'react';
import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import {
    handle_product_details,
} from '../../Redux/reducer';
import {
    getCartDetails,
    // getBillNumber,
    updateBillNumber,
    addSubscription,
    deleteSubscription
} from '../../Redux/actions';

import PayButton from '../Payment/Frontend/App'

// Icons 
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';

// Illustrations
import paymentFailureImage from '../../assets/Broken bulb.png';
import paymentSuccessImage from '../../assets/Completion.png';

//Invoice
import {PDFViewer} from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
// import Invoice from './components/reports/Invoice'
// import invoice from './data/invoice'
import Invoice from '../Invoice/components/reports/Invoice'
// import invoice from '../Invoice/data/invoice';

const PaymentResult = () => {
    
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const productDetails = useSelector((state) => state.auth.productDetails);
    const user = useSelector((state) => state.auth.user);
    const invoice = useSelector((state) => state.auth.invoice);
    const subscriptions = useSelector((state) => state.auth.subscriptions);
    let url = window.location.href;
    let lastSlashIndex = url.lastIndexOf("=");
    var paymentResult = url.substr(lastSlashIndex + 1);
    // console.log("lohith:PaymentResult:productDetails = ",paymentResult,": user = ",user,"",": invoice = ",invoice);
    // console.log("lohith:PaymentResult:subscriptions 1= ",subscriptions);

    // useEffect(
    //     () => {
    //         dispatch(getBillNumber("receipt"));
    //     },
    //     [1],
    // );

    useEffect(
        () => {
            // console.log("lohith:PaymentResult:useEffect");
            if(invoice.items.length <= 0) {
                window.location.replace("https://www.airender.co.in/");
            } 
            else if (paymentResult === 'success') {
                if(Object.keys(subscriptions).length > 0){
                    // console.log("lohith:PaymentResult:subscriptions 2= ",subscriptions);
                    // Delete the subscription if it's greater than today
                    var today = new Date();
                    Object.keys(subscriptions).map(function(key) {
                        var endDate = new Date(subscriptions[key].to_date)
                        if(today > endDate){
                            // console.log("lohith:PaymentResult:subscriptions 2.1= ",subscriptions[key]);
                            dispatch(deleteSubscription(user.email))
                        } else {
                            // console.log("lohith:PaymentResult:subscriptions 2.2= ",subscriptions[key]);
                            dispatch(getCartDetails(user.email));
                            window.alert("subscription still valid");
                        }
                    })
                } else {
                    // console.log("lohith:PaymentResult:subscriptions 3= ",subscriptions);
                    dispatch(updateBillNumber("receipt", invoice.invoice_no));
                    invoice.items.map((item) => {
                        dispatch(addSubscription(isAuthenticated, user, invoice, item.name));
                    })
                }
            }
        },
        [1],
    );

    return(
        <div>
            <div className='paymentResult-section'>
                <div className="paymentResult-buttons-container">
                    <Link to='/payment' 
                        className="paymentResult-back-button"
                        onClick={()=>{
                    }}
                    >
                        <ChevronLeftIcon /> Back
                    </Link>
                    {paymentResult === 'success'
                    ?<PDFDownloadLink 
                        document={<Invoice invoice={invoice}/>} 
                        fileName="Airender-Invoice.pdf" 
                        className="paymentResult-download-button"
                    >
                        {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download invoice!')}
                    </PDFDownloadLink>:null}
                </div>
                {paymentResult === 'success'
                ?<div className='paymentResult-success-message'>
                    <div className='paymentResult-success-message-1'>
                        <h1>Payment Successful!</h1>
                        <CheckCircleOutlineIcon fontSize='large'/>
                    </div>
                    <h3 className='paymentResult-success-message-2'>Happy Video Conferencing</h3>
                    <img src={paymentSuccessImage} className='paymentResult-success-image' alt='FailureImage'/>
                </div>
                :<div className='paymentResult-failure-message'>
                    <div className='paymentResult-failure-message-1'>
                        <h1>Payment Failure!</h1>
                        <SentimentVeryDissatisfiedIcon fontSize='large'/>
                    </div>
                    <h3 className='paymentResult-failure-message-2'>Please try again later</h3>
                    <img src={paymentFailureImage} className='paymentResult-failure-image' alt='FailureImage'/>
                </div>}
                {/* {paymentResult === 'success'
                ?<div className='paymentResult-PDF-container'>
                    <Fragment>
                        <PDFViewer width="1000" height="600" className="paymentResult-PDF" >
                            <Invoice invoice={invoice}/>
                        </PDFViewer>
                    </Fragment>
                </div>:null} */}
            </div>
        </div>
    )
}

export default PaymentResult;